// extracted by mini-css-extract-plugin
export var actions = "_kw-g";
export var benefitCard = "_kw-b";
export var benefitIcon = "_kw-d";
export var benefitLabel = "_kw-f";
export var benefits = "_kw-a";
export var benefitsSection = "_kw-8";
export var bodyText = "_kw-7";
export var closeButton = "_kw-2";
export var content = "_kw-3";
export var eyebrow = "_kw-4";
export var heading = "_kw-5";
export var image = "_kw-i";
export var imagePanel = "_kw-h";
export var modal = "_kw-0";
export var offerCard = "_kw-c";
export var offerIcon = "_kw-e";
export var sectionLabel = "_kw-9";
export var shell = "_kw-1";
export var title = "_kw-6";